import { AdminSearchApplications } from "../components/AdminSearchApplications";
import CustForm from "../components/CustForm";
export function AdminUnsubscribe() {
    document.title = `Търсене - Отписване`;

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Отписване</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Отписване</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <AdminSearchApplications action='cancelAfterExpiredRanking' />
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminUnsubscribe;